/** @format */

import { action, computed } from 'easy-peasy';

const ContactModel = {
	Name: '',
	Email: '',
	PhoneNumber: '',
	PhoneNumberRaw: '',
	PhoneData: null,
	SmsAccepted: true,
	// SMS can only be sent to Norwegian numbers. PhoneData is null until the user types; the input defaults to Norway.
	IsSmsSupported: computed((state) => !state.PhoneData || state.PhoneData.countryCode === 'no'),
	LPN: '',
	CarLength: '',
	TermsAccepted: false,
	NameError: null,
	EmailError: null,
	PhoneNumberError: null,
	TermsAcceptedError: false,
	LPNError: null,
	CarLengthError: null,

	setName: action((state, name) => {
		state.Name = name;
	}),
	setEmail: action((state, email) => {
		state.Email = email;
	}),
	setPhone: action((state, phoneData) => {
		state.PhoneNumber = phoneData.Number;
		state.PhoneData = phoneData.Data;
		state.PhoneNumberRaw = state.PhoneNumber.replace(/[^0-9]+/g, '').slice(phoneData.Data.dialCode.length);
		if (phoneData.Data.countryCode !== 'no') state.SmsAccepted = false;
		// Re-validated on blur; don't keep a stale error while the user is typing or switching country
		state.PhoneNumberError = null;
	}),
	setSmsAccepted: action((state, smsAccepted) => {
		state.SmsAccepted = smsAccepted;
	}),
	setLPN: action((state, lpn) => {
		state.LPN = lpn;
	}),
	setCarLength: action((state, carLength) => {
		state.CarLength = carLength;
	}),
	setTermsAccepted: action((state, termsAccepted) => {
		state.TermsAccepted = termsAccepted;
	}),
	setNameError: action((state, error) => {
		state.NameError = error;
	}),
	setEmailError: action((state, error) => {
		state.EmailError = error;
	}),
	setPhoneError: action((state, error) => {
		state.PhoneNumberError = error;
	}),
	setTermsAcceptedError: action((state, error) => {
		state.TermsAcceptedError = error;
	}),
	setLPNError: action((state, error) => {
		state.LPNError = error;
	}),
	setCarLengthError: action((state, error) => {
		state.CarLengthError = error;
	}),
	reset: action((state) => {
		state.Name = '';
		state.LPN = '';
		state.Email = '';
		state.PhoneNumber = '';
		state.PhoneNumberRaw = '';
		state.CarLength = '';
		state.PhoneData = null;
		state.SmsAccepted = true;
		state.TermsAccepted = false;
		state.NameError = null;
		state.EmailError = null;
		state.PhoneNumberError = null;
		state.TermsAcceptedError = false;
		state.LPNError = null;
		state.CarLengthError = null;
	}),
};

export default ContactModel;
